export default __webpack_public_path__ + "static/music-843694dd308a0b64d39e5b6a6a39c257.webp";